import React from 'react';
import Icon from './AppIcon';

const NotificationBadge = ({ count = 0, severity = 'info', onClick, className = '' }) => {
  if (count === 0) return null;

  const severityColors = {
    info: 'bg-blue-500',
    warning: 'bg-yellow-500',
    critical: 'bg-red-500'
  };

  const severityIcons = {
    info: 'bell',
    warning: 'alert-triangle',
    critical: 'alert-circle'
  };

  const bgColor = severityColors?.[severity] || severityColors?.info;
  const icon = severityIcons?.[severity] || severityIcons?.info;

  return (
    <button
      onClick={onClick}
      className={`relative inline-flex items-center justify-center p-2 rounded-full hover:bg-gray-100 transition-colors ${className}`}
      aria-label={`${count} unread notifications`}
    >
      <Icon name={icon} className="w-6 h-6 text-gray-700" />
      {count > 0 && (
        <span
          className={`absolute -top-1 -right-1 ${bgColor} text-white text-xs font-bold rounded-full min-w-[20px] h-5 flex items-center justify-center px-1.5 animate-pulse`}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
};

export default NotificationBadge;